import { render } from "./TableContent.vue?vue&type=template&id=0dc60e95&ts=true"
import script from "./TableContent.vue?vue&type=script&lang=ts"
export * from "./TableContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__